import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { AcModel } from 'projects/core/src/lib/models/ac.model';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { Table } from 'primeng/table';
import * as moment from 'moment';

const AC_LIST_MODES = [
  'planned',
  'running',
  'finished',
  'cancelled',
];

@Component({
  selector: 'app-ac-list',
  templateUrl: './ac-list.component.html',
  styleUrls: ['./ac-list.component.scss']
})
export class AcListComponent extends BaseList implements OnInit {

  @ViewChild('dt') dataTableComponent: Table;

  public acs: Array<AcModel> = [];
  public mode = 'planned';
  public title: string = null;
  public dst: boolean = moment().isDST();

  protected apiUrl = '/acs';

  faEnvelope = faEnvelope;

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService,
    private route: ActivatedRoute,
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.mode && AC_LIST_MODES.indexOf(params.mode) !== -1) {
          this.mode = params.mode;
          this.title = this.transloco.translate('ac_list.' + this.mode);
          this.ui.setPageTitle(this.title);
          this.loadList();
      } else {
        this.router.navigate(['dashboard']);
      }
    });
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('acs', {
      mode: this.mode
    }).subscribe({
      next: (acs: any) => {
        this.acs = [];
        acs.data.forEach((ac: any) => {
          this.acs.push(new AcModel().deserialize(ac));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
       this.loading = false;
    });
  }

  onNew(): void {
    if (this.auth.hasRight('admin.ac.create')) {
      this.router.navigate(['/acs', this.mode, 'new']);
    }
  }

  onOpen(ac: AcModel): void {
    if (this.auth.hasRight('admin.ac.show')) {
      this.router.navigate(['/acs', this.mode, ac.id]);
    }
  }

  setup(value: any, id: string): void {
    if (value !== null) {
      this.dataTableComponent.filters[id][0].value = value;
    }
  }

  getDstLabel(): string {
    return ' (' + ((this.dst) ? 'MESZ' : 'MEZ') + ')';
  }

}
